<template>
  <div>
    <div>
      <el-row style="background-color: #34495e; opacity: 0.85">
        <a href="/#/">
          <el-image :src="require('@/assets/logo.png')"></el-image>
          <span
            style="
              color: #ffa71d;
              font-size: 14px;
              position: absolute;
              margin-left: 10px;
            "
            >问卷调查</span
          >
        </a>
      </el-row>
    </div>
  </div>
</template>

<script>
import DwNavMenu from "@/components/layouts/DwNavMenu.vue";
import DwAuthorized from "@/utils/dw-authorized";
import { logout } from "@/api/dw-login";

export default {
  name: "DwHeader",
  components: {
    "dw-nav-menu": DwNavMenu,
  },
  data() {
    return {
      userName: "dwsurvey",
    };
  },
  mounted() {
    this.userName = DwAuthorized.getUserName();
  },
  methods: {
    handleCommand: function (command) {
      if (command === "logout") {
        logout().then(() => {
          this.$router.push("/login");
        });
      } else if (command === "myAccount") {
        this.$router.push("/dw/user");
      } else if (command === "updatePwd") {
        this.$router.push("/dw/user/pwd");
      }
    },
  },
};
</script>

<style scoped>
.dw-header-main {
  padding: 0px;
}
.el-dropdown-link {
  color: white;
}
.m-logbg {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwHeader.vue